import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withRef(Component: React.ComponentType<any>) {
  const WithRef = React.forwardRef((props, ref) => {
    return <Component {...props} ref={ref} />;
  });

  WithRef.displayName = `withRef(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WithRef;
}
